export default(() => {
    const dropdowns = Array.from(document.querySelectorAll('.link-dropdown'));

    dropdowns.forEach((dropdown) => {
        dropdown.addEventListener('click', (e) => {
            e.stopPropagation();
            dropdown.classList.toggle('link-dropdown--active');
        });

        document.body.addEventListener('click', () => {
            dropdown.classList.remove('link-dropdown--active');
        });
    });

})();
